import { useState } from 'react';

const BioFull = ({ bioFull }) => {
  const TRUNCATED_LENGTH = 300;
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldTruncate = bioFull.length > TRUNCATED_LENGTH;

  const displayText =
    shouldTruncate && !isExpanded
      ? `${bioFull.slice(0, TRUNCATED_LENGTH)}...`
      : bioFull;

  return (
    <div className="text-sm text-muted-foreground">
      <span>{displayText}</span>

      {shouldTruncate && (
        <div className="flex justify-end py-2">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="hover:underline"
          >
            {isExpanded ? 'Read less' : 'Read more'}
          </button>
        </div>
      )}
    </div>
  );
};

export default BioFull;
